import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import Trns from 'src/localization/Trns'
import { NotificationSettingListModel } from 'src/models/notificationSetting.models'
import { selectIsCspAuthenticatedFromState } from 'src/redux/selectors/auth.selectors'
import { PatchNotificationSettingsRequest } from 'src/requests/patchNotificationSettings.request'
import { css } from 'styled-components'

interface SettingProps {
  email?: NotificationSettingListModel | undefined
  push?: NotificationSettingListModel | undefined
}

interface NotificationSettingsGroupItemProps {
  settings: SettingProps[]
  patchNotifications: (body: PatchNotificationSettingsRequest) => void
  title: React.ReactElement
  label?: string
}

const NotificationSettingsGroupItem: React.FC<
  NotificationSettingsGroupItemProps
> = (props) => {
  const { analytics } = useAnalyticsContext()
  const isCspAuthenticated = useSelector(selectIsCspAuthenticatedFromState)

  const handleTurnOnNotif = (
    label: string | undefined,
    notificationType: string,
    trigger: string | undefined,
    title: string,
  ): void => {
    label !== undefined &&
      trigger !== undefined &&
      analytics?.track(
        'notifications ' +
          label +
          ' - ' +
          trigger +
          ' (' +
          title +
          ') ' +
          notificationType +
          ' - checkbox press',
        {
          screen: '/notifications',
          interaction: 'check press',
          intent:
            notificationType + ' ' + label + ' ' + trigger + ' notifications',
        },
      )
  }

  const handleTurnOffNotif = (
    label: string | undefined,
    notificationType: string,
    trigger: string | undefined,
    title: string,
  ): void => {
    label !== undefined &&
      trigger !== undefined &&
      analytics?.track(
        'notifications ' +
          label +
          ' - cancel ' +
          trigger +
          ' (' +
          title +
          ') ' +
          notificationType +
          ' - checkbox press',
        {
          screen: '/notifications',
          interaction: 'check press',
          intent:
            'cancel ' +
            notificationType +
            ' ' +
            label +
            ' ' +
            trigger +
            ' notifications',
        },
      )
  }
  const onSingleClick = (setting?: NotificationSettingListModel): void => {
    if (setting !== undefined) {
      props.patchNotifications({
        notificationSettings: [
          {
            id: setting.id,
            enabled: !setting.enabled,
          },
        ],
      })
    }
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }
      `}
    >
      <span
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {props.title}
      </span>
      {Object.values(props.settings).map((setting, i) => (
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
          `}
          key={i}
        >
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            {setting.email?.label || setting.push?.label}
          </span>
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 200px;
            `}
          >
            <Checkbox
              css={css`
                ${setting.email === undefined &&
                css`
                  opacity: 0;
                  pointer-events: none;
                `}
              `}
              onClick={(): void => {
                onSingleClick(setting.email)
                setting.email?.enabled
                  ? handleTurnOffNotif(
                      props.label,
                      'Email',
                      setting.email?.label,
                      props.title.props.source,
                    )
                  : handleTurnOnNotif(
                      props.label,
                      'Email',
                      setting.email?.label,
                      props.title.props.source,
                    )
              }}
              label={<Trns source={'Email'} />}
              isSelected={!!setting.email?.enabled}
              disabled={isCspAuthenticated}
            />
            <Checkbox
              css={css`
                ${setting.push === undefined &&
                css`
                  opacity: 0;
                  pointer-events: none;
                `}
                margin-left: 30px;
              `}
              onClick={(): void => {
                onSingleClick(setting.push)
                setting.push?.enabled
                  ? handleTurnOffNotif(
                      props.label,
                      'Push',
                      setting.push?.label,
                      props.title.props.source,
                    )
                  : handleTurnOnNotif(
                      props.label,
                      'Push',
                      setting.push?.label,
                      props.title.props.source,
                    )
              }}
              label={<Trns source={'Push'} />}
              isSelected={!!setting.push?.enabled}
              disabled={isCspAuthenticated}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default NotificationSettingsGroupItem
